/**
 * Copyright (c) 2010-2026 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */

import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AuthService } from '@core/security/services/auth.service';
import { env } from '@env/environment-factory';
import { catchError, of, take } from 'rxjs';
import { Logger } from './logger.service';

@Injectable({ providedIn: 'root' })
export class BackendLoggerService implements Logger {

    http = inject(HttpClient);

    debug(...args: any[]) {
        if (env.debug) {
            this.logToBackend('debug', args);
        }
    }

    error(...args: any[]) {
        this.logToBackend('error', args);
    }

    info(...args: any[]) {
        this.logToBackend('info', args);
    }

    trace(...args: any[]) {
        this.logToBackend('trace', args);
    }

    warn(...args: any[]) {
        this.logToBackend('warn', args);
    }

    private logToBackend(level: string, content: any) {
        const body = {
            level,
            content,
        }
        this.http.post(`${ env.apiBase }/api/log/client`, body, {reportProgress: false}).pipe(
            take(1),
        ).subscribe();
    }
}